import { Control } from "../../business-objects/control/control.model";
import { ControlConfig, IControlConfigArgs } from "../../business-objects/control/control-config.model";

export interface IComplexControlConfigArgs extends IControlConfigArgs {
    showTitle?: boolean;
    labelsColSize?: string;
    showHeaders?: boolean;
    showToolbar?: boolean;
    controls: Array<Control>;
}

const defaults = (): IComplexControlConfigArgs => ({
    ...new ControlConfig(),
    showTitle: false,
    labelsColSize: "7",
    showHeaders: false,
    showToolbar: false,
    controls: []
});

export class ComplexControlConfig extends ControlConfig {
    showTitle: boolean;
    labelsColSize: string;
    showHeaders: boolean;
    showToolbar: boolean;
    controls: Array<Control>;

    constructor(data?: IComplexControlConfigArgs) {
        super({...defaults(), ...data});
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/complex/complex-control-config.model.ts